
; (function ($, window, document, undefined) {

    var name = 'customSelection';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customSelection.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$selections = this.$element.find('[data-event="selection"]');
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('click', '[data-event="selection"]', function (e) {
                if ($(e.target).is('a', 'input, select, textarea')) {
                    return;
                }

                plugin.selectItem($(this).data('value'));
            });
        },

        unbindEvents: function () {
            this.$element.off();
        },

        selectItem: function (value) {
            var selected = this.$selections.filter((index, selection) => $(selection).data('value') == value);
            if (!selected) {
                this.$element.trigger('error.customSelection.selection', [this, {
                    responseJSON: {
                        error: {
                            message: 'Selected item does not existed.'
                        }
                    }
                }]);

                return;
            }

            selected.toggleClass('active');
            if (!this.options.multipleSelection && selected.hasClass('active')) {
                this.$selections.not(selected).removeClass('active');
            }

            this.$element.trigger('change.customSelection.selection', [this, value]);
        },

        val: function (values = null) {
            if (values) {
                this.$selections.removeClass('active');
                values.forEach(value => {
                    this.selectItem(value);
                });
            }

            return this.$selections.filter((index, selection) => $(selection).hasClass('active')).map((index, selection) => $(selection).data('value')).toArray();
        },
    });

    $.fn.customSelection = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customSelection.defaults = {
        multipleSelection: false,
    };
})(jQuery, window, document);
